import { environment } from '../../../environments/environment';
import { ChartSelectionCard } from '../Interfaces/chart-selection-card';
import { AppConstants } from './app-constants';

export class ScatterChartConstants {
  scatterChartImgFolderPath: string = '../../../assets/Images/Scatter/';
  /*baseUrl: string = environment.baseUrl;*/
  scatterChartModuleRoutePath =
    AppConstants.scatterCategoryPathMap.chartModuleRoutePath + '/';
  chartDescriptions: any = this.getChartDescriptions();
  barChartModuleComponentPath: string =
    AppConstants.scatterCategoryPathMap.moduleFolderPath;

  //contains the details of all kinds of bar charts that is available in th tool
  scatterChartTypes: ChartSelectionCard[] = [
    {
      imgUrl: "",
      routePath: this.scatterChartModuleRoutePath + 'scatterchart01Custom',
      routePath2: '',
      description: [],
      chartFolderPath: this.barChartModuleComponentPath + 'scatterchart01',
      chartFolderPath2: '',
      imgClassName: 'scatterChart',
      chartTitle: 'Scatter Chart DN',  //DN -Dont show purpose check chart-select-widget lib
      chartId: 1,
      chartSelectedNumber: 0,
      isEnabled: false,
      chartGroup: "Scatter chart"
    },
    {
      imgUrl: "",
      routePath: this.scatterChartModuleRoutePath + 'scatterchart02Custom',
      routePath2: '',
      description: [],
      chartFolderPath: this.barChartModuleComponentPath + 'scatterchart02',
      chartFolderPath2: '',
      imgClassName: 'quadrantScatterChart',
      chartTitle: 'Scatter Chart',
      chartId: 2,
      chartSelectedNumber: 0,
      isEnabled: true,
      chartGroup: "Scatter chart"
    },
    {
      imgUrl: "",
      routePath: this.scatterChartModuleRoutePath + 'bubblechart01Custom',
      routePath2: '',
      description: [],
      chartFolderPath: this.barChartModuleComponentPath + 'bubblechart01',
      chartFolderPath2: '',
      imgClassName: 'bubbleChart',
      chartTitle: 'Bubble Chart DN',  //DN -Dont show purpose check chart-select-widget lib
      chartId: 3,
      chartSelectedNumber: 0,
      isEnabled: false,
      chartGroup: "Scatter chart"
    },
    {
      imgUrl: "",
      routePath: this.scatterChartModuleRoutePath + 'bubblechart02Custom',
      routePath2: '',
      description: [],
      chartFolderPath: this.barChartModuleComponentPath + 'bubblechart02',
      chartFolderPath2: '',
      imgClassName: 'quadrantBubbleChart',
      chartTitle: 'Bubble Chart',
      chartId: 4,
      chartSelectedNumber: 0,
      isEnabled: true,
      chartGroup: "Scatter chart"
    },
    // {
    //   imgUrl: "",
    //   routePath: this.scatterChartModuleRoutePath + 'abacuschart01',
    //   routePath2: '',
    //   description: [],
    //   chartFolderPath: this.barChartModuleComponentPath + 'abacuschart01',
    //   chartFolderPath2: '',
    //   imgClassName: 'abacusChart',
    //   chartTitle: 'Abacus Chart',
    //   chartId: 5,
    // },
    // {
    //   imgUrl: this.scatterChartImgFolderPath + '06barchart.png',
    //   routePath: this.scatterChartModuleRoutePath + 'BarChart6',
    //   routePath2: '',
    //   description: [],
    //   chartFolderPath: this.barChartModuleComponentPath + 'barchart6',
    //   chartFolderPath2: '',
    //   imgClassName: '',
    //   chartTitle: '',
    //   chartId: 6,
    // },
    // {
    //   imgUrl: this.scatterChartImgFolderPath + '07barchart.png',
    //   routePath: this.scatterChartModuleRoutePath + 'BarChart7',
    //   routePath2: '',
    //   description: [],
    //   chartFolderPath: this.barChartModuleComponentPath + 'barchart7',
    //   chartFolderPath2: '',
    //   imgClassName: '',
    //   chartTitle: '',
    //   chartId: 7,
    // },
    // {
    //   imgUrl: this.scatterChartImgFolderPath + '08barchart.png',
    //   routePath: this.scatterChartModuleRoutePath + 'BarChart8',
    //   routePath2: '',
    //   description: [],
    //   chartFolderPath: this.barChartModuleComponentPath + 'barchart8',
    //   chartFolderPath2: '',
    //   imgClassName: '',
    //   chartTitle: '',
    //   chartId: 8,
    // },
    // {
    //   imgUrl: this.scatterChartImgFolderPath + '09barchart.png',
    //   routePath: this.scatterChartModuleRoutePath + 'BarChart9',
    //   routePath2: '',
    //   description: [],
    //   chartFolderPath: this.barChartModuleComponentPath + 'barChart9',
    //   chartFolderPath2: '',
    //   imgClassName: '',
    //   chartTitle: '',
    //   chartId: 9,
    // },
    // {
    //   imgUrl: this.scatterChartImgFolderPath + '10barchart.png',
    //   routePath: this.scatterChartModuleRoutePath + 'BarChart10',
    //   routePath2: '',
    //   description: [],
    //   chartFolderPath: this.barChartModuleComponentPath + 'barChart10',
    //   chartFolderPath2: '',
    //   imgClassName: '',
    //   chartTitle: '',
    //   chartId: 10,
    // },
    // {
    //   imgUrl: this.scatterChartImgFolderPath + '11barchart.png',
    //   routePath: this.scatterChartModuleRoutePath + 'BarChart11',
    //   routePath2: '',
    //   description: [],
    //   chartFolderPath: this.barChartModuleComponentPath + 'barchart11',
    //   chartFolderPath2: '',
    //   imgClassName: '',
    //   chartTitle: '',
    //   chartId: 11,
    // },
    // {
    //   imgUrl: this.scatterChartImgFolderPath + '12barchart.png',
    //   routePath: this.scatterChartModuleRoutePath + 'BarChart12',
    //   routePath2: '',
    //   description: [],
    //   chartFolderPath: this.barChartModuleComponentPath + 'barchart12',
    //   chartFolderPath2: '',
    //   imgClassName: '',
    //   chartTitle: '',
    //   chartId: 12,
    // },
    // {
    //   imgUrl: this.scatterChartImgFolderPath + '13barchart.png',
    //   routePath: this.scatterChartModuleRoutePath + 'BarChart13',
    //   routePath2: '',
    //   description: [],
    //   chartFolderPath: this.barChartModuleComponentPath + 'barchart13',
    //   chartFolderPath2: '',
    //   imgClassName: '',
    //   chartTitle: '',
    //   chartId: 13,
    // },
  ];

  //Returns the descriptions that has to be displayed in customization section of each bar chart
  getChartDescriptions() {
    let genericDescription = [
      'Bar color could be single solid colour, solid multicolour, linear gradient.',
      'Grid lines in both x-axis and y-axis can be solid, long dash, short dash etc. \
          according to the requirements and can be provided with different styles.',
      'On x-axis text, images can be added.',
    ];
    let chartDescription = {
      barChart1: [
        'Colour of the bar can be solid single colour, solid multicolour or linear gradient.',
        'X-axis line can be in solid or any styled format.',
        'Each bar chart can be called out.',
        'Grid lines in y axis can be styled in any way.',
        'Shadow can be applied on the bar.',
        'Data label can be fixed position or absolute position (above each bar chart).In data label \
          you can add text, formatter (text or glyph font icon).',
        'Bar texture (repeated pattern) can be applied.',
      ],

      barChart2: [
        ...genericDescription,
        'Data Labels - For the different colour on top of columns formatter is used \
          that returns value as well as the colour from the data.',
      ],

      genericBarChartDescription: genericDescription,
    };

    return chartDescription;
  }
}
